export default __webpack_public_path__ + "static/media/tennesseeTitansVideo-2x.03ace816.jpg";